import { useEventTracker } from 'mmfintech-checkout-commons'
import { isNotEmptyString, tr } from 'mmfintech-commons'
import { CoreButton, LabelValue } from '../../../components'
import { useEffect } from 'react'

import './PreviewBankwire.scss'

export const PreviewBankwire = ({ result, session, sessionId }) => {
  const { successUrl } = session || {}

  const {
    recipientAddress,
    bankName,
    bankAddress,
    iban,
    bicSwift,
    bankCode,
    branchCode,
    accountNumber,
    accountOwner,
    bankCountryCode,
    accountType,
    // documentId,
    // documentType,
    reference
  } = result

  const { trackEvent } = useEventTracker()

  const handleRedirect = () => {
    void trackEvent(sessionId, 'redirected_back_to_merchant')
    window.location.href = successUrl
  }

  // noinspection SpellCheckingInspection
  const formatAccountNumber = (): string | null =>
    accountNumber ? `${accountType === 'BANKGIRO' ? 'BG ' : ''}${accountNumber}` : null

  const getCountryCode = () => (bankCountryCode ? bankCountryCode : iban && iban.substring(0, 2) === 'GB' ? 'GBR' : '')

  useEffect(() => {
    void trackEvent(sessionId, 'manual_bank_transfer_details_shown')
  }, [])

  return (
    <div className='preview-bankwire-wrapper'>
      <div className='preview-title' data-test='bank-transfer-details'>
        {tr('FRONTEND.DEPOSIT.PREVIEW.TITLE', 'Bank Transfer Details')}
      </div>

      <LabelValue label={tr('FRONTEND.DEPOSIT.PREVIEW.BANK_NAME', 'Bank Name')} value={bankName} dataTest='bank-name' />
      <LabelValue
        label={tr('FRONTEND.DEPOSIT.PREVIEW.BANK_ADDRESS', 'Bank Address')}
        value={bankAddress}
        dataTest='bank-address'
      />
      <LabelValue label={tr('FRONTEND.DEPOSIT.PREVIEW.IBAN', 'IBAN')} value={iban} dataTest='iban' />
      <LabelValue label={tr('FRONTEND.DEPOSIT.PREVIEW.BIC_SWIFT', 'BIC/SWIFT')} value={bicSwift} dataTest='bic-swift' />
      <LabelValue
        label={tr(
          `FRONTEND.DEPOSIT.PREVIEW.BANK_NUMBER_${getCountryCode()}`,
          tr('FRONTEND.DEPOSIT.PREVIEW.BANK_NUMBER', 'Bank number')
        )}
        value={bankCode}
        dataTest='bank-number'
      />
      <LabelValue
        label={tr('FRONTEND.DEPOSIT.PREVIEW.BRANCH_CODE', 'Branch code')}
        value={branchCode}
        dataTest='branch-code'
      />
      <LabelValue
        label={tr('FRONTEND.DEPOSIT.PREVIEW.ACCOUNT_NUMBER', 'Account number')}
        value={formatAccountNumber()}
        dataTest='account-number'
      />
      <LabelValue
        label={tr('FRONTEND.DEPOSIT.PREVIEW.ACCOUNT_OWNER', 'Account owner')}
        value={accountOwner}
        dataTest='account-owner'
      />
      <LabelValue
        label={tr('FRONTEND.DEPOSIT.PREVIEW.OWNER_ADDRESS', 'Owner address')}
        value={recipientAddress}
        dataTest='recipient-address'
      />
      <LabelValue
        label={tr('FRONTEND.DEPOSIT.PREVIEW.REFERENCE', 'Reference')}
        value={reference}
        dataTest='reference'
      />

      {isNotEmptyString(reference) && (
        <div className='warning-wrapper'>
          {tr(
            'FRONTEND.DEPOSIT.PREVIEW.WARNING1',
            'Please pay attention to enter your unique reference to your transaction. If the reference is blank or wrong, the transaction will be declined and you will need to enter the correct reference and try again.'
          )}
        </div>
      )}

      {Boolean(successUrl) && (
        <CoreButton
          type='button'
          variation='primary'
          onClick={handleRedirect}
          text={tr('CHECKOUT.BUTTONS.CLOSE', 'Close')}
          data-test='button-back'
        />
      )}
    </div>
  )
}
